import { Dispatch } from 'redux';
import axios from '../../axios';
import {
  ClearResendEmailMessageAction,
  GoogleSignInAction,
  ResendEmailAction,
  SignInAction,
  SignOutAction,
} from './auth.types';

export const SIGN_IN = 'SIGN_IN';
export const GOOGLE_SIGN_IN = 'GOOGLE_SIN_IN';
export const CALL_GOOGLE_CALLBACK = 'CALL_GOOGLE_CALLBACK';
export const CALL_GOOGLE_CALLBACK_FAILURE = 'CALL_GOOGLE_CALLBACK_FAILURE';
export const RESEND_EMAIL = 'RESEND_EMAIL';
export const CLEAR_RESEND_EMAIL_MESSAGE = 'CLEAR_RESEND_EMAIL_MESSAGE';
export const SIGN_OUT = 'SIGN_OUT';
export const SEND_FORGOT_PASSWORD_EMAIL = 'SEND_FORGOT_PASSWORD_EMAIL';
export const SEND_FORGOT_PASSWORD_EMAIL_FAILURE =
  'SEND_FORGOT_PASSWORD_EMAIL_FAILURE';
export const VERIFY_RESET_PASSWORD_CODE = 'VERIFY_RESET_PASSWORD_CODE';
export const VERIFY_RESET_PASSWORD_CODE_FAILURE =
  'VERIFY_RESET_PASSWORD_CODE_FAILURE';
export const TOGGLE_APP = 'TOGGLE_APP';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

export const signIn = (authCode: string) => async (
  dispatch: Dispatch<SignInAction>
): Promise<void> => {
  try {
    const user = await axios.get(`/auth-code/${authCode}`);
    localStorage.setItem('token', user.data.payload.jwt);
    localStorage.setItem('refresh', user.data.payload.refreshJWTToken);
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'token'
    )}`;
    const org = await axios.get(`/services/orgs/${user.data.payload.orgId}`);
    dispatch({
      type: SIGN_IN,
      payload: { user: user.data.payload, org: org.data.payload },
    });
  } catch (e) {
    console.log(e.message);
  }
};

export const googleSignIn = () => async (
  dispatch: Dispatch<GoogleSignInAction>
): Promise<void> => {
  const response = await axios.get(`/google-login/dashboard`);
  dispatch({
    type: GOOGLE_SIGN_IN,
    payload: `${response.data.payload.url}`,
  });
};

export const callGoogleCallback = (search: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const res = await axios.get(`/google-callback/dashboard${search}`);
    const user = res.data.payload;
    localStorage.setItem('refresh', user.refreshJWTToken);
    localStorage.setItem('token', user.jwt);
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'token'
    )}`;
    const org = await axios.get(`/services/orgs/${user.orgId}/`);
    dispatch({
      type: CALL_GOOGLE_CALLBACK,
      payload: { user, org: org.data.payload },
    });
  } catch (e) {
    dispatch({
      type: CALL_GOOGLE_CALLBACK_FAILURE,
    });
  }
};

export const resendEmail = () => async (
  dispatch: Dispatch<ResendEmailAction>
): Promise<void> => {
  const res = await axios.get('/request-verify-email');
  if (res.data.code === 200)
    dispatch({
      type: RESEND_EMAIL,
      payload: 'Email was resent successfully',
    });
};

export const clearResendEmailMessage = (): ClearResendEmailMessageAction => ({
  type: CLEAR_RESEND_EMAIL_MESSAGE,
});

export const signOut = () => async (
  dispatch: Dispatch<SignOutAction>
): Promise<void> => {
  await axios.get('/logout');
  dispatch({
    type: SIGN_OUT,
  });
};

export const sendForgotPasswordEmail = (email: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    await axios.post('/reset-password', { email });
    dispatch({
      type: SEND_FORGOT_PASSWORD_EMAIL,
    });
  } catch (e) {
    dispatch({
      type: SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
    });
  }
};

export const verifyResetPasswordCode = (code: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    await axios.get(`/reset-password/${code}`);
    dispatch({
      type: VERIFY_RESET_PASSWORD_CODE,
    });
  } catch (e) {
    dispatch({
      type: VERIFY_RESET_PASSWORD_CODE_FAILURE,
    });
  }
};

export const toggleEmailAnalyzer = (
  active: boolean,
  appName: string,
  orgId: string
) => async (dispatch: Dispatch): Promise<void> => {
  await axios.patch(`/services/orgs/${orgId}/apps/${appName}`, {
    active,
  });
  dispatch({
    type: TOGGLE_APP,
    payload: { active, appName },
  });
};

export const refreshToken = () => async (dispatch: Dispatch): Promise<void> => {
  try {
    const refresh = localStorage.getItem('refresh');
    if (!refresh) return;
    const res = await axios.get(`/refresh-token/${refresh}`);
    const user = res.data.payload;
    localStorage.setItem('refresh', user.refreshJWTToken);
    localStorage.setItem('token', user.jwt);
    axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
      'token'
    )}`;
    const org = await axios.get(`/services/orgs/${user.orgId}`);
    dispatch({
      type: REFRESH_TOKEN,
      payload: {
        user,
        org: org.data.payload,
      },
    });
  } catch (e) {
    console.log(e.message);
  }
};
export const getUserData = (orgId: string, userId: string) => async (
  dispatch: Dispatch
): Promise<void> => {
  try {
    const response = await axios.get(`/services/orgs/${orgId}/users/${userId}`);
    dispatch({
      type: REFRESH_TOKEN,
      payload: {
        user: response.data.payload,
      },
    });
  } catch (e) {
    console.log(e.message);
  }
};
